const viewJobButtonStyle = {
    textTransform: 'none',
    color: '#edbb2a',
    fontSize: '17px',
    fontWeight: '500'
};

export {viewJobButtonStyle};